import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import DesignPreferencePage from './DesignPreferencePage';
import { getdesignPreferencesData, goEditDesignPreference } from 'src/actions/editDesignPreferenceAction';
import { saveBranchType } from 'src/actions/fileuploadAction';

export const mapStateToProps = (state: AppState) => {
  return {
    orderDataBranch: state.fileUpload.orderDataBranch
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onComponentDidMount: () => {
      dispatch(getdesignPreferencesData);
    },
    goEditDesignPreference: (sbu: string) => {
      dispatch(goEditDesignPreference(sbu));
      dispatch(saveBranchType(sbu));
    }
  };
};

const DesignPreferencePageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DesignPreferencePage);

export default DesignPreferencePageContainer;



// WEBPACK FOOTER //
// ./src/components/designPreferences/DesignPreferencePageContainer.tsx